import Navigation from "../components/Navigation";
import { HeroSection } from "../components/sections/HeroSection";
import { FeaturesSection } from "../components/sections/FeaturesSection";
import { PricingStrip } from "../components/sections/PricingStrip";
import { FaqSection } from "../components/sections/FaqSection";
import { Footer } from "../components/sections/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Navigation />
      <HeroSection />
      <FeaturesSection />
      <PricingStrip />
      <FaqSection />
      <Footer />
    </div>
  );
};

export default Index;
